import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

export default {
    parse(data) {
        // ['sla_nbd'].forEach(item => {
        //     data[item] = parseInt(data[item]);
        // });

        ['valor_referencia'].forEach(item => {
            if (data[item]) {
                data[item] = parseFloat(data[item]);
            }
        });

        ['data_instalacao', 'data_primeiro_pagamento', 'data_vencimento'].forEach(item => {
            if (data[item]) {
                data[item] = new Date(data[item] + "T00:00:00");
            }
        });

        return data;
    },
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/list${params}`, Token.getHeader());
    },
    vigente(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/vigente${params}`, Token.getHeader());
    },
    vigenteDownload(params="") {
        params = params ? `${params}&download=1` : 'download=1';

        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/contrato/vigente?${params}`, headers);
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/contrato/download${params}`, headers);
    },
    listAgendamento(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/listAgendamento${params}`, Token.getHeader());
    },
    totalConcluidoVigente(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/totalConcluidoVigente${params}`, Token.getHeader());
    },
    totalCotacao(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/totalCotacao${params}`, Token.getHeader());
    },
    totalContratacao(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/totalContratacao${params}`, Token.getHeader());
    },
    totalCancelado(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/totalCancelado${params}`, Token.getHeader());
    },
    todosContratoPorProvedorAtivo(provedor){
        if(provedor) provedor = `?provedor=${provedor}`;
        return axios.get(`/api/contrato/todosContratoPorProvedorAtivo${provedor}`, Token.getHeader());
    },
    backlog(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/backlog${params}`, Token.getHeader());
    },
    totalMeusContratos(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/totalMeusContratos${params}`, Token.getHeader());
    },
    minhasEtapasSemanal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/minhasEtapasSemanal${params}`, Token.getHeader());
    },
    minhasEtapasQuantidade(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/minhasEtapasQuantidade${params}`, Token.getHeader());
    },
    etapasSemanal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/etapasSemanal${params}`, Token.getHeader());
    },
    etapasMensal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/etapasMensal${params}`, Token.getHeader());
    },
    etapasQuantidade(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/etapasQuantidade${params}`, Token.getHeader());
    },
    usuariosQuantidade(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/usuariosQuantidade${params}`, Token.getHeader());
    },
    mesesQuantidade(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/mesesQuantidade${params}`, Token.getHeader());
    },
    estadosQuantidade(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/estadosQuantidade${params}`, Token.getHeader());
    },
    clientesQuantidade(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/clientesQuantidade${params}`, Token.getHeader());
    },
    concluidosMensal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/concluidosMensal${params}`, Token.getHeader());
    },
    concluidosDiario(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/concluidosDiario${params}`, Token.getHeader());
    },

    agendamentosDiario(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato/agendamentosDiario${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/contrato`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/contrato/${id}`, params, Token.getHeader());
    },
    updateResponsavel(params) {
        return axios.post(`/api/contrato/updateResponsavel`, params, Token.getHeader());
    },
    updateCotacao(params) {
        return axios.post(`/api/contrato/updateCotacao`, params, Token.getHeader());
    },
    updateObservacoes(id, params) {
        return axios.post(`/api/contrato/updateObservacoes/${id}`, params, Token.getHeader());
    },
    proximoRequisitos(id) {
        return axios.get(`/api/contrato/proximo-requisitos/${id}`, Token.getHeader());
    },
    proximo(id,params={}) {
        return axios.post(`/api/contrato/proximo/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/contrato/${id}`, Token.getHeader());
    },
}
